import clsx from "clsx";
import React from "react";

export interface SkeletonProps {
  className?: string;
  height?: number | string;
  width?: number | string;
}

export function Skeleton({ className, height = 40, width = "100%" }: SkeletonProps) {
  return (
    <div
      style={{ height, width }}
      className={clsx("bg-dark bg-opacity-10 animate-pulse rounded-xl", className)}
    />
  );
}
